<template>
  <div
    v-if="showAuthenticatedLayout"
    class="app tracking-[.02em] text-accent-800"
  >
    <div v-show="auth0?.isAuthenticated">
      <HeaderNavBar />
      <SidebarSideBar />
      <div class="content__wrapper">
        <div class="w-full">
          <div class="top-nav-buffer" />
          <div>
            <div class="flex justify-center">
              <div class="content-container content-container-authenticated">
                <slot />
              </div>
            </div>
            <FooterDefaultFooter class="ml-24" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="app tracking-[.02em] text-accent-800">
    <div class="content__wrapper">
      <div class="w-full">
        <div>
          <div class="flex justify-center">
            <div class="content-container content-container-unauthenticated">
              <slot />
            </div>
          </div>
          <FooterDefaultFooter />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeMount, watch, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useAuth0 } from "@auth0/auth0-vue";
import { useRoute } from "#vue-router";
import { IsUnauthenticatedRoute } from "~/utils/IsUnauthenticatedRoute";
import { useSearchStore } from "~/store/search";

const auth0 = useAuth0();
const $route = useRoute();
const savedSearchStore = useSearchStore();

onBeforeMount(() => {
  if (process.client) {
    const { locale } = useI18n();
    let userLanguage = localStorage.getItem("language");
    if (userLanguage === "null") userLanguage = null;

    locale.value = userLanguage ?? "en-us";
  }
});

const route = computed(() => {
  return $route.name as string;
});

watch(
  () => route.value,
  (newVal) => {
    savedSearchStore.currentRoute = newVal;
  },
);

onMounted(() => {
  savedSearchStore.currentRoute = route.value;
});

const showAuthenticatedLayout = computed(() => {
  return process.server
    ? !IsUnauthenticatedRoute($route?.path ?? "")
    : auth0?.isAuthenticated?.value &&
        !IsUnauthenticatedRoute($route?.path ?? "");
});
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Inter:300,400,700&display=swap");

.app {
  @apply bg-white min-h-screen font-sans;
}
.content__wrapper {
  @apply flex;
}
.top-nav-buffer {
  @apply h-18;
}
/* .content-container {
  @apply w-full flex-1 overflow-hidden 2xl:max-w-[110rem] bg-white rounded-lg ml-28 mr-4 my-3;
} */
.content-container {
  @apply w-full flex-1 overflow-hidden 2xl:max-w-[110rem] bg-white;
}
.content-container-authenticated {
  @apply ml-22 mr-6 my-4;
}
.content-container-unauthenticated {
  @apply mt-10;
}
</style>
